(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inaklam-bildgravur-modern"] && !Shopify.designMode) return;
  try {
    
function initBildgravur(root) {
 if (root.dataset.ready) return;
 root.dataset.ready = 'true';
 const grid = root.querySelector('.ibg-grid');
 if (!grid) return;
 const products = [...grid.querySelectorAll('.ibg-product')];
 const tools = root.querySelector('.ibg-tools');
 if (!products.length || root.querySelector('.ibg-pagination')) return;
 tools.hidden = false;
 const count = root.querySelector('[data-count]');
 root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
  const filter = button.dataset.filter;
  root.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  products.forEach(product => product.hidden = filter !== 'all' && product.dataset.shape !== filter);
  const total = products.filter(product => !product.hidden).length;
  count.textContent = total + (total === 1 ? ' Kette' : ' Ketten');
 }));
 root.querySelector('select').addEventListener('change', event => {
  const mode = event.target.value;
  [...products].sort((a,b) => mode === 'manual' ? Number(a.dataset.order)-Number(b.dataset.order) : mode === 'price-ascending' ? Number(a.dataset.price)-Number(b.dataset.price) : Number(b.dataset.price)-Number(a.dataset.price)).forEach(product => grid.append(product));
 });
}
document.querySelectorAll('.inaklam-bildgravur').forEach(initBildgravur);
document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('.inaklam-bildgravur').forEach(initBildgravur));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inaklam-bildgravur-preview"]) return;
  try {
    
function initBildgravur(root) {
 if (root.dataset.ready) return;
 root.dataset.ready = 'true';
 const grid = root.querySelector('.ibg-grid');
 if (!grid) return;
 const products = [...grid.querySelectorAll('.ibg-product')];
 const tools = root.querySelector('.ibg-tools');
 if (!products.length || root.querySelector('.ibg-pagination')) return;
 tools.hidden = false;
 const count = root.querySelector('[data-count]');
 root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
  const filter = button.dataset.filter;
  root.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  products.forEach(product => product.hidden = filter !== 'all' && product.dataset.shape !== filter);
  const total = products.filter(product => !product.hidden).length;
  count.textContent = total + (total === 1 ? ' Kette' : ' Ketten');
 }));
 root.querySelector('select').addEventListener('change', event => {
  const mode = event.target.value;
  [...products].sort((a,b) => mode === 'manual' ? Number(a.dataset.order)-Number(b.dataset.order) : mode === 'price-ascending' ? Number(a.dataset.price)-Number(b.dataset.price) : Number(b.dataset.price)-Number(a.dataset.price)).forEach(product => grid.append(product));
 });
}
document.querySelectorAll('.inaklam-bildgravur').forEach(initBildgravur);
document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('.inaklam-bildgravur').forEach(initBildgravur));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inaklam-partnerschmuck"] && !Shopify.designMode) return;
  try {
    (()=>{const init=()=>{document.querySelectorAll('.inaklam-partner').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelector('.ip-idea-tabs').hidden=false;const ideas=[['L ♡ M','M ♡ L'],['14.06.2022','14.06.2022'],['48.8583° N','2.2945° E']];root.querySelectorAll('[data-idea]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-idea]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));const pair=ideas[Number(b.dataset.idea)];root.querySelector('[id^="engraving-small-"]').textContent=pair[0];root.querySelector('[id^="engraving-large-"]').textContent=pair[1];root.querySelector('[id^="idea-story-"]').textContent=['Zwei Initialen. Und alles, was dazwischen liegt.','Der Tag, an dem aus zwei Geschichten eine wurde.','Paris, Eiffelturm. Ein Ort, auf zwei Ketten verteilt. Vielleicht Euer erster gemeinsamer Urlaub, Euer Lieblingsplatz oder der Ort Eures ersten Kusses.'][Number(b.dataset.idea)];}));});};init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();
})();
